import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import {
  isExternalJob,
  getExternalApplyUrl,
  getSourceName,
  getSourceLabel,
  withUtm,
} from "@/lib/jobUtils";

interface StickyMobileCTAProps {
  job: any;
  user: any;
  authLoading: boolean;
  existingApplication: any;
}

/**
 * Sticky bottom CTA bar visible only on mobile (lg:hidden).
 * Mirrors the 3-state CTA logic from the sidebar.
 */
export function StickyMobileCTA({ job, user, authLoading, existingApplication }: StickyMobileCTAProps) {
  const isExternal = isExternalJob(job);
  const externalUrl = getExternalApplyUrl(job);
  const sourceName = getSourceName(job);
  const nextParam = `/oportunidades/${job.id}`;

  // Already applied
  if (user && !isExternal && existingApplication) {
    return (
      <div className="fixed bottom-0 inset-x-0 z-40 bg-green-50 dark:bg-green-950/80 border-t border-green-200 dark:border-green-900 p-3 text-center lg:hidden">
        <p className="text-sm font-medium text-green-700 dark:text-green-300">Candidatura já enviada</p>
      </div>
    );
  }

  // Anonymous
  if (!user && !authLoading) {
    return (
      <div className="fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border p-3 lg:hidden">
        <Button asChild className="w-full" size="lg">
          <Link to={`/aluno/escolha?next=${encodeURIComponent(nextParam)}`}>Criar conta e candidatar</Link>
        </Button>
      </div>
    );
  }

  // Logged in + external
  if (user && isExternal) {
    return (
      <div className="fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border p-3 lg:hidden">
        <Button className="w-full" size="lg" onClick={() => window.open(withUtm(externalUrl!), "_blank")}>
          Candidatar no {getSourceLabel(sourceName)}
          <ExternalLink className="ml-2 h-4 w-4" />
        </Button>
      </div>
    );
  }

  // Logged in + internal
  if (user) {
    return (
      <div className="fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border p-3 lg:hidden">
        <Button asChild className="w-full" size="lg">
          <Link to={`/aluno/vagas/${job.id}/aplicar`}>Candidatar-me</Link>
        </Button>
      </div>
    );
  }

  return null;
}
